// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2248":"css/admin-app.6709","9155":"css/app.6709"}[chunkId] + ".css";
};